import { helpers } from './base'

export const CancellationPolicyModal = helpers.defineMultiStyleConfig({
  baseStyle: {
    cancellationFeesAndPoliciesContainer: {
      h1: {
        fontSize: '2xl',
        my: { base: 4, lg: 6 },
      },
      strong: {
        fontWeight: 'light',
      },
      p: {
        fontSize: { base: 'sm', lg: 'md' },
      },
    },
    policyLink: {
      color: 'brand.highlight.blue',
      fontSize: { base: 'sm', lg: 'md' },

      _hover: {
        textDecoration: 'none',
      },
    },
  },
})
